import { CDN_DEV_URL, CDN_PROD_URL } from '../types.js';

const getCDNBaseUrl = (stage) => {
    return stage === 'dev' ? CDN_DEV_URL : CDN_PROD_URL;
};

export { getCDNBaseUrl };
//# sourceMappingURL=serverService.js.map
